import * as React from 'react'
import Alert from '@mui/material/Alert'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import ErrorOutline from '@mui/icons-material/ErrorOutline'
import Typography from '@mui/material/Typography'

interface Props {
  count: number
  onUpdateRequiredFields: () => void
}

export function LeadAutoCloseMissingFieldsBanner(props: Props) {
  const { count, onUpdateRequiredFields } = props

  return (
    <Box mt={1} mb="20px">
      <Alert
        severity="error"
        icon={<ErrorOutline sx={{ fontSize: 22, color: '#D63B1F' }} />}
        sx={{ backgroundColor: '#FBECE9', color: '#621B0E' }}
        action={
          <Button
            size="small"
            color="inherit"
            onClick={onUpdateRequiredFields}
            data-test-id="lead-auto-close-missing-fields-update-button"
            sx={{ fontWeight: '500', width: 'max-content' }}
          >
            Update Required Fields
          </Button>
        }
        data-test-id="lead-auto-close-missing-fields-banner"
      >
        <Typography variant="body2">
          You have {count} required fields to complete so this lead can
          auto-close/win.
        </Typography>
      </Alert>
    </Box>
  )
}

LeadAutoCloseMissingFieldsBanner.displayName =
  'LeadAutoCloseMissingFieldsBanner'
